module.exports = __webpack_public_path__ + "static/media/icon-check-in.dc90b7f3.svg";